import { actionTypes } from './constants';
import { conditionInsightsTabs, getAllKPITrendChartList, getAnomalyDetectionKPI, getDriveKPIList } from './helpers';
const initialState = {
    conditionInsightsTrendKpis: {
        trendKPI: [],
        anomalyDetectionKPI: []
    },
    conditionInsightsDriveStatus: {
        driveKPI: [],
    },
    assetInfo: {
        assetId: null,
        conditionStatus: null
    },
    loadingStatus: null,
    data: null,
    error: null,
    zoom: {
        isZoomed: false,
        from: null,
        to: null
    },
    activeTab: conditionInsightsTabs.CONDITION_INDICES,
    driveAnomalyActiveTab: null,
    showConditionForecast: false,
    retraining: {
        loadingStatus: null,
        data: null,
        error: null
    },
    kpiFromSummary: null
};

// eslint-disable-next-line import/no-unused-modules
export const reducer = (state = initialState, action) => {
    switch (action.type) {
        //COMMON SECTION
        case actionTypes.GET_ASSET_KPI_TREND_LIST: {
            return {
                ...state,
                conditionInsightsTrendKpis: {
                    trendKPI: getAllKPITrendChartList(action?.data
                        ?.trendChartKPIS, state?.conditionInsightsTrendKpis?.trendKPI),
                    anomalyDetectionKPI: getAnomalyDetectionKPI(action?.data
                        ?.trendChartKPIS, state?.conditionInsightsTrendKpis?.anomalyDetectionKPI)
                },
                conditionInsightsDriveStatus: {
                    driveKPI: getDriveKPIList(action?.data?.trendChartKPIS,
                        state?.conditionInsightsDriveStatus?.driveKPI)
                },
                assetInfo: {
                    conditionStatus: action?.data?.assetConditionStatus,
                    assetId: action?.data?.assetID
                },
                loadingStatus: action?.loadingStatus,
                data: action?.data || null,
                error: action?.error || null,
            };
        }
        case actionTypes.ADD_SELECTED_TREND_KPI_DATA: {
            return {
                ...state,
                zoom: {
                    ...state.zoom,
                    isZoomed: action?.data?.isZoomed,
                    from: action?.data?.from,
                    to: action?.data?.to
                }
            };
        }
        case actionTypes.RELOAD_CONDITION_INSIGHTS_SUCCESS: {
            return {
                ...state,
                zoom: {
                    ...state.zoom,
                    isZoomed: action?.data?.isZoomed,
                    from: action?.data?.from,
                    to: action?.data?.to
                }
            };
        }
        case actionTypes.SET_CONDITION_INSIGHTS_ZOOM_SUCCESS: {
            return {
                ...state,
                zoom: {
                    ...state.zoom,
                    isZoomed: action?.data?.isZoomed
                }
            };
        }
        case actionTypes.CLEAR_STORE: {
            return initialState;
        }
        case actionTypes.SET_ACTIVE_CONDITION_INSIGHTS_TAB:
            return {
                ...state,
                activeTab: action.activeTab,
            };
        case actionTypes.SET_DRIVE_ANOMALY_ACTIVE_TAB:
            return {
                ...state,
                driveAnomalyActiveTab: action.driveAnomalyActiveTab,
            };
        case actionTypes.TOGGLE_CONDITION_FORECAST:
            return {
                ...state,
                showConditionForecast: action.enabled,
            };
        case actionTypes.GET_RETRAINING_PROGRESS:
            return {
                ...state,
                retraining: {
                    loadingStatus: action?.loadingStatus,
                    data: action?.data || null,
                    error: action?.error || null
                }
            };
        case actionTypes.SET_KPI_FROM_SUMMARY_TAB: {
            return {
                ...state,
                kpiFromSummary: action.payload
            };
        }
        default:
            return state;
    }
};
